import { AppConfig } from '../types';
import { UNITY_BUILD_PATHS, UNITY_METADATA } from './unityBuild';

// UNIFIED Unity Build - single build serves both character editor and dungeon
// React controls which scene to load via HeadlessGameController.InitializeGame()
// Configuration is centralized in ./unityBuild.ts - update there after Unity rebuilds
const unifiedUnityConfig = {
  ...UNITY_BUILD_PATHS,
  ...UNITY_METADATA,
};

// Legacy aliases - both now point to unified build
const characterEditorUnityConfig = unifiedUnityConfig;
const gameUnityConfig = unifiedUnityConfig;

// Export character editor config for profile page
export const characterEditorConfig = characterEditorUnityConfig;

export const datingConfig: AppConfig = {
  id: 'dating',
  name: 'GameDate',
  description: 'Find your perfect match through adventure',
  theme: {
    primaryColor: '#F1D557',    // Solar Yellow - CTAs (10% usage)
    secondaryColor: '#F9E99E',  // Starfruit glow - hover states
    backgroundColor: '#162B49', // Midnight Navy - serious (70%)
    textColor: '#F8FAFC',       // Slate 50 - crisp white
    accentColor: '#36BAC6',     // Blue Curaçao - bridge (20%)
    violetColor: '#89CFF0',     // Crystal Blue - icy highlights
  },
  unity: {
    ...gameUnityConfig,
    productName: 'GameDate',
  },
  features: {
    showHeader: true,
    showFooter: true,
    showLoadingScreen: true,
    showFullscreenButton: true,
    allowChat: true,
    showPlayerList: true,
    customButtons: [
      { id: 'profile', label: 'Profile', action: 'openProfile' },
      { id: 'matches', label: 'Matches', action: 'openMatches' },
    ],
  },
};

export const classroomConfig: AppConfig = {
  id: 'classroom',
  name: 'Quest Academy',
  description: 'Learning through adventure',
  theme: {
    primaryColor: '#2196f3',
    secondaryColor: '#64b5f6',
    backgroundColor: '#f5f5f5',
    textColor: '#333333',
    accentColor: '#4caf50',
  },
  unity: {
    ...gameUnityConfig,
    productName: 'QuestAcademy',
  },
  features: {
    showHeader: true,
    showFooter: true,
    showLoadingScreen: true,
    showFullscreenButton: true,
    allowChat: true,
    showPlayerList: true,
    customButtons: [
      { id: 'dm-panel', label: 'DM Controls', action: 'openDMPanel' },
      { id: 'students', label: 'Students', action: 'openStudentList' },
      { id: 'quests', label: 'Quests', action: 'openQuests' },
    ],
  },
};

export const presets: Record<string, AppConfig> = {
  dating: datingConfig,
  classroom: classroomConfig,
};

export const getConfig = (mode: string): AppConfig => {
  return presets[mode] || datingConfig;
};
